import { ChartLineIcon } from '@lokalise/louis'
import type { EvaluationMetrics } from '@lokalise/translation-api-schemas'
import src from '../../../assets/evals-banner-ellpise.svg'
import { EvaluationMetricsTable } from '../../EvaluationMetricsTable/EvaluationMetricsTable'
import { StandaloneEvaluationMetricsTableWrapper } from '../../EvaluationMetricsTable/StandaloneEvaluationMetricsTableWrapper/StandaloneEvaluationMetricsTableWrapper'
import { UpTo40PercentLessEdits } from '../../RadialDial/RadialDial'
import { useDispatchBannerAnalyticsEvent } from '../hooks/useDispatchBannerAnalyticsEvent'
import {
  BannerContainer,
  BannerHeader,
  BannerSubHeader,
  BannerTextContainer,
} from './BannerComponents'
import styles from './EvalsBanner.module.css'

const DUMMY_RESULTS: EvaluationMetrics = {
  perfectMatch: {
    evaluatedProfileResult: { value: 0.602, isBest: true },
    baseProfileResult: { value: 0.11, isBest: null },
    machineTranslationResult: { value: 0.08, isBest: null },
  },
  translationEditRate: {
    evaluatedProfileResult: { value: 0.2, isBest: true },
    baseProfileResult: { value: 0.54, isBest: null },
    machineTranslationResult: { value: 0.61, isBest: null },
  },
  bleu: {
    evaluatedProfileResult: { value: 0.65, isBest: true },
    baseProfileResult: { value: 0.44, isBest: null },
    machineTranslationResult: { value: 0.4, isBest: null },
  },
  chrf: {
    evaluatedProfileResult: { value: 0.88, isBest: true },
    baseProfileResult: { value: 0.61, isBest: null },
    machineTranslationResult: { value: 0.55, isBest: null },
  },
  meteor: null,
  aiScore: null,
  pastAiScore: null,
  engines: null,
}

export const EvalsBanner = () => {
  useDispatchBannerAnalyticsEvent('evaluation')

  return (
    <BannerContainer>
      <BannerTextContainer>
        <BannerSubHeader>AUTOMATIC QUALITY CHECK</BannerSubHeader>
        <BannerHeader>
          See the difference <br />
          for yourself.
        </BannerHeader>
        <p className={styles.bodyText}>
          Use evaluation to prove the value of Custom Profiles. Benchmark against Base AI Profile
          and Google Translate and demonstrate up to 40% less editing effort with significantly
          higher exact-match performance.
        </p>
      </BannerTextContainer>
      <div className="flex-col gap-2 items-center">
        <UpTo40PercentLessEdits />
        <p className={styles.subText}>
          Custom profiles comparing <br />
          to Base AI profile
        </p>
      </div>
      <div className={styles.ctaContainer}>
        <div className={styles.tableContainer}>
          <div className={styles.tableInner}>
            <StandaloneEvaluationMetricsTableWrapper>
              <EvaluationMetricsTable
                profileName="Custom profile for Marketing"
                results={DUMMY_RESULTS}
              />
            </StandaloneEvaluationMetricsTableWrapper>
          </div>
        </div>
        <div className={styles.fakeButtonContainer}>
          <div className={styles.fakeButton}>
            <ChartLineIcon size="13px" color="var(--lok-color-text-action-alt-primary)" />
            Evaluate
          </div>
          <img src={src} aria-hidden />
        </div>
      </div>
    </BannerContainer>
  )
}
